import React, { useState } from 'react';
import './DeleteAccount.css';
import 'bootstrap/dist/css/bootstrap.min.css';

export const DeleteAccount = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleInputChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleDelete = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch('https://ecommerce-app-2.up.railway.app/api/v1/user/delete', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password}),
      });


      if (response.ok) {
        setMessage('Account deleted successfully.');
      } else {
        setMessage('Failed to delete account.');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('An error occurred. Please try again.');
    }
  };

  return (
    <div className="delete-account-container">
      <div className="delete-account-form">
        <h1>Eco Trends</h1>
        <h2>Delete Your Account</h2>
        <form onSubmit={handleDelete}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              className="form-control"
              id="email"
              value={email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              className="form-control"
              id="password"
              value={password}
              onChange={handlePasswordChange}
              required
            />
          </div>
          <button type="submit" className="btn btn-danger">Delete Account</button>
        </form>
        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
};
